// import { ListBoxChangeEvent } from "primereact/listbox";
import { useState } from "react";
import CustomerAPIDataSourceImpl from "../../Data/DataSource/API/CustomerAPIDataSource";
import { CustomerRepositoryImpl } from "../../Data/Repository/CustomerRepositoryImpl";
import { Customer } from "../../Domain/Model/Customer";
// import { CreateColor } from "../../Domain/UseCase/CreateColor";
import { GetCustomers } from "../../Domain/UseCase/GetCustomers";
import { PaginationResult } from "../../../../Shared/Model/PaginationResult";
// import { RemoveColor } from "../../Domain/UseCase/RemoveColor";
// import { UpdateColor } from "../../Domain/UseCase/UpdateColor";

export default function CustomerViewModel() {

    const [customers, setCustomers] = useState<Customer[]>([]);

    const customerDataSourceImpl = new CustomerAPIDataSourceImpl();
    const customerRepositoryImpl = new CustomerRepositoryImpl(customerDataSourceImpl);

    const getCustomersUseCase = new GetCustomers(customerRepositoryImpl);
    // const createColorUseCase = new CreateColor(colorRepositoryImpl);
    // const removeColorUseCase = new RemoveColor(colorRepositoryImpl);
    // const updateColorUseCase = new UpdateColor(colorRepositoryImpl);

    async function getCustomers(page: number, size: number, search: string): Promise<{ items: Customer[]; totalCount: number }> {
        //setCustomers(await getCustomersUseCase.invoke());

        try {
                const result: PaginationResult<Customer> = await getCustomersUseCase.invoke(page, size, search );
            
                await setCustomers(result.items); // Si quieres mantenerlo en el ViewModel
                
            
                return {
                  items: result.items,
                  totalCount: result.totalCount, // usar totalCount según tu interfaz
                };
              } catch (error) {
                console.error("Error al obtener Clientes:", error);
                return { items: [], totalCount: 0 };
              }
      }

      // function _resetValue() {
      //   setValue("");
      // }

      // async function createColor(data: Customer) {
      //   try {
      //     const createdColor = await createColorUseCase.invoke(data);
      //     if(createdColor){
      //       console.log("enviado");
      //     }
      //     //_resetValue();
      //   } catch (e) {
      //     //_resetValue();
      //     if (e instanceof Error) {
      //       console.log(e.message);
      //     }
      //   }
      // }

      // async function removeColor(id: string) {
      //   try {
      //     let removedColor = await removeColorUseCase.invoke(id);
      //     if(removedColor){
      //       console.log("eliminado");
      //      return removedColor;
          
      //     }
      //     //_resetValue();
      //   } catch (e) {
      //     //_resetValue();
      //     if (e instanceof Error) {
      //       console.log(e.message);
      //     }
      //     return Error;
      //   }
      // }

      // async function updateColor(data: Color) {
      //   try {
      //     let updatedColor = await updateColorUseCase.invoke(data);
      //     if(updatedColor){
      //       console.log("Actualizado");
      //      return updatedColor;
          
      //     }
      //     //_resetValue();
      //   } catch (e) {
      //     //_resetValue();
      //     if (e instanceof Error) {
      //       console.log(e.message);
      //     }
      //     return Error;
      //   }
      // }


      // function onChangeColor(e: ListBoxChangeEvent) {
      //   e.preventDefault();
      //   setColors(e.target.value);
      // }
      
      return {
        getCustomers,
        // createColor,
        // removeColor,
        // updateColor,
        // onChangeColor,
        customers,
      };
}